import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from '../auth/login/login.service';

@Injectable({
  providedIn: 'root',
})
export class TicketsService {
  constructor(private http: HttpClient, private loginSvc: LoginService) {}

  getDistribuidoresSubproyectos(proyectoPadre: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        proyectoPadre: proyectoPadre,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Bearer ' + accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL +
            '/clientesolicitante/get-distribuidores-subproyectos',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_cliente', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  getCategoriesProyecto(proyecto: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        proyecto: proyecto,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Bearer ' + accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-categories-proyecto',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_categories_proyecto', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  crearTicket(data: any): Observable<any> {
    return new Observable<any>((observer) => {
      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      const params = data;

      const url = environment.API_URL + '/clientesolicitante/create-ticket';
      this.http.post(url, params, options).subscribe(
        (response: any) => {
          console.log('ws crearTicket', response);
          observer.next(response);
        },
        (err) => {
          console.log('error ws crearTicket', err);
          let msgError = 'Se ha producido un error guardando los datos';

          if (err.error.error === 'invalid_no_fk_entities') {
            msgError = 'El fk_entities indicado no existe';
          } else if (err.error.message) {
            msgError = err.error.message;
          }

          observer.error(msgError);
        }
      );

			return { unsubscribe() { } };
		});
	}

	downloadAdjunto(idTicket: number, idAdjunto: number) {
		return new Observable<any>((observer) => {
      const accessToken = this.loginSvc.getAccessToken();

			const headers = new HttpHeaders({
				Authentication: "Bearer " + accessToken,
				// 'Content-Type': 'application/json; charset=utf-8'
				"Content-Type": "application/octet-stream"
			});

			const url = environment.API_URL + "/tickets/" + idTicket + "/descarga-adjunto/" + idAdjunto;
			this.http.get(url, { responseType: "blob", headers: headers }).subscribe(
				(response: any) => {
					console.log("generar etiqueta entrada", response);
					const file = new Blob([response], { type: response.type });
					const fileUrl = window.URL.createObjectURL(file);
					console.log("file url pdf", fileUrl);
					observer.next(fileUrl);
				},
				(err) => {
					console.log("error ws descargarAdjunto", err);
					let msgError = "Se ha producido un error";

					observer.error(msgError);
				}
			);

			return { unsubscribe() {} };
		});
	}

  getCategoriesPasos(sintoma: number): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        sintoma,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-categories-pasos',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_pasos_sintomas', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  changeStatusTicket(ticketId: number, status: string): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        ticketId,
        status,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Bearer ' + accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/change-status-ticket',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_cliente', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  changeStatusTicketClient(ticketId: number, status: string): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        ticketId,
        status,
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL +
            '/clientesolicitante/change-status-ticket-client',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            console.log('ws changeStatusTicketClient', response);
            observer.next(response);
          },
          (err) => {
            console.error('error changeStatusTicketClient', err);
            observer.error('Se ha producido un error');
          }
        );
    });
  }

  seguimientosTicket(ticketId: number): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        ticketId,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-ticket-seguimientos',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_seguimientos', err);
            observer.error(err.error.message);
          }
        );
    });
  }

  buscarTicket(ticketId: number): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        ticketId,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-ticket',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_cliente', err);
            observer.error(err.error.message);
          }
        );
    });
  }

  crearSeguimiento(ticketId: number, contents: string, adjuntosIds?: number[]): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        ticketId,
        contents,
        lista_adjuntos: adjuntosIds
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/create-seguimiento',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error crearSeguimiento', err.error);
            observer.error(err.error.message);
          }
        );
    });
  }

  comprobarActivo(numserie: string): Observable<any> {
    return new Observable<any>((observer) => {
      const body = {
        numserie: numserie,
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/comprobar-activo-ultimo',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_cliente', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  getImageElementoInventario(idArticulo: number): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Bearer ' + accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .get(
          environment.API_URL +
            '/almacenes/maestro-articulos/imagen/' +
            idArticulo,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_cliente', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  uploadAdjunto(
    idTicket: number,
    tipoAdjunto: number,
    fileName: string,
    imagenBase64: any
  ): Observable<any> {
    return new Observable<any>((observer) => {
      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          'API-Key': environment.apiKey,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      const params = {
        tipo_adjunto: tipoAdjunto,
        app: 0,
        file: {
          base64: imagenBase64,
          filename: fileName,
        },
      };

      console.log('params: ', params);

			const url = environment.API_URL + '/tickets/' + idTicket + '/upload-adjunto';
			this.http.post(url, params, options).subscribe({
				next: (response: any) => {
					console.log("ws uploadAdjunto", response);
					observer.next(response);
					observer.complete();
				},
				error: (err) => {
					console.log("error ws uploadAdjunto", err);
					let msgError = "Se ha producido un error guardando los datos";
					observer.error(msgError);
				}
			});

      return { unsubscribe() {} };
    });
  }

  getCitasTicketsCliente(ticketsIds: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        ticketsIds,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Bearer ' + accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-citas-tickets-cliente',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_citas_tickets_cliente', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  getTicketsClienteHoy(proyecto: any, cliente: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        proyecto,
        cliente,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Bearer ' + accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-tickets-cliente-hoy',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_cliente', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }

  getTicketsCliente(proyecto: any, cliente: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        proyecto,
        cliente,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Bearer ' + accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-tickets-cliente',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error get_tickets_cliente', err);
            let msgError = 'Se ha producido un error';
            observer.error(msgError);
          }
        );
    });
  }
}
